<template>
  <div class="wrapper d-flex justify-content-center align-items-center">
    <div class="boxes shadow">
      <h2 class="text-dark">Log in</h2>
      <p>Sebelum masuk ke sistem</p>
      <form method="post" @submit.prevent="login">
        <div class="py-3">
          <div class="mb-3">
            <input type="text" v-model="form.username" class="form-control" placeholder="Username" autofocus autocapitalize="off" />
          </div>
          <div class="input-group mb-3">
            <input :type="(showpass ? 'text':'password')" v-model="form.password" class="form-control" placeholder="Password" />
            <div class="input-group-append">
              <span class="input-group-text cp" @mousedown="start" @mouseleave="stop" @mouseup="stop" @touchstart="start" @touchend="stop" @touchcancel="stop">
                <icon v-if="showpass" :icon="['far', 'eye']" />
                <icon v-if="!showpass" :icon="['far', 'eye-slash']" />
              </span>
            </div>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-model="form.remember" type="checkbox" id="remember-me" />
            <label class="form-check-label" for="remember-me">Ingat Saya</label>
          </div>
          <div class="mt-3" v-if="err_message">
            <div class="alert alert-danger" v-text="err_message"></div>
          </div>
          <div class="mt-3">
            <Link href="/"><p>Kembali ke Halaman Awal</p></Link>
          </div>
        </div>
        <div class="py-2 text-end">
          <button type="submit" class="btn btn-primary px-4">Masuk</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errors: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        username: '',
        password: '',
        remember: false,
      }),
      err_message: "",
      showpass: false,
    }
  },
  methods: {
    login() {
      this.form.post('/auth/login', {
        onError: (errors) => {
          this.err_message = errors[Object.keys(errors)[0]];
        }
      })
    },
    start() {
      if (!this.showpass) {
        this.showpass = setInterval(() => {}, 30)
      }
    },
    stop() {
      clearInterval(this.showpass)
      this.showpass = false
    },
  },
}
</script>

<style lang="scss">
@import '../../../css/bootstrap';
</style>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #74ebd5;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to bottom, #ACB6E5, #74ebd5);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to bottom, #ACB6E5, #74ebd5); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.boxes {
  padding: 3.5rem 2.5rem;
  background: #fff;
  width: 100%;
  max-width: 30em;
}

.form-control, .input-group-text {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  padding-left: 0;
}

.input-group-text {
  padding: 0.47rem 0.75rem;
  display: block;
  cursor: pointer;
}

.form-check-label {
  font-weight: normal;
}
</style>